<template>
    <div>
      <div class="grey-bg" @click.stop="donotTouchMe">
        <div class="content">
          <h4></h4>
          <p v-html='des'></p>
          <div v-if='type==1' class="btn-div">
            <div @click="cut">确认</div>
            <div @click="movewish">移入心愿单</div>
          </div>
          <div v-if='type==2' class="btn-div">
            <div @click="cut">删除</div>
            <div @click="movewish">移入心愿单</div>
          </div>
          <div v-if='type==3' class="btn-div2">
            <div @click="checkout">继续结算</div>
          </div>
          <div v-if='type==4' class="btn-div2">
            <div @click="ensure">确认</div>
          </div>
        </div>
      </div>
    </div>
</template>
<style lang="less" scoped>
  .grey-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.3);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content {
    text-align: center;
    background-color: #ffffff;
    width: 80%;
    padding: 40px 20px;
    h4 {
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 30px;
      font-size: 12px;
      color: #585858;
    }
  }
  .btn-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      width: 45%;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      color: #ffffff;
      &:nth-of-type(1) {
        background-color: #1973cd;
      }
      &:nth-of-type(2) {
        background-color: #a70011;
      }
    }
  }
  .btn-div2 {
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      width: 75%;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      color: #ffffff;
      background-color: #1973cd;
    }
  }
</style>
<script>

    export default{
        data(){
            return{

            }
        },
        props: {
          title: String,
          des: String,
          type: Number
        },
        methods:{
          cut() {
            this.$emit('cut');
          },
          movewish() {
            this.$emit('movewish');
          },
          checkout() {
            this.$emit('continueCheck');
          },
          ensure() {
            this.$emit('hidePopup')
          },

          donotTouchMe(){
            console.log("do not touch me");
          }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/common/Popup.vue